export default __webpack_public_path__ + "pgnv-assets/bdd0bdc80e917615ab6d26d25378379f.png";